const baseUrl = process.env.VUE_APP_BASEURL
const baseLiveApiUrl = process.env.VUE_APP_BASE_LIVEAPI_URL
const kvSyncApiUrl = process.env.VUE_APP_AHA_SYNC_URL
const kvSyncApiBasePath = process.env.VUE_APP_AHA_SYNC_BASE_PATH
const baseUrlSocket = process.env.VUE_APP_BASEURLSOCKET
const domain = process.env.VUE_APP_DOMAIN
const backstageDomain = process.env.VUE_APP_BACKSTAGEDOMAIN
const sentryRelease = process.env.VUE_APP_GIT_COMMIT
const sentry = process.env.VUE_APP_SENTRY
const env = process.env.VUE_APP_ENVAPP
const workerUrl = process.env.VUE_APP_BASEWORKERTURL
const presenterDomain = process.env.VUE_APP_PRESENTERDOMAIN
const audienceLink = process.env.VUE_APP_AUDIENCEDOMAIN
const aiChatbotDomain = process.env.VUE_APP_AI_CHATBOT_DOMAIN
const stripePublicKey = process.env.VUE_APP_STRIPE_PUBLIC_KEY
const sentryEnabled = process.env.VUE_APP_SENTRY_ENABLED === 'true'
const singaporeStripePublishableKey = process.env.VUE_APP_SINGAPORE_STRIPE_PUBLISHABLE_KEY
const MAX_NUMBER_OF_SLIDE = process.env.VUE_APP_MAX_NUMBER_OF_SLIDE || 500
const MAX_FOLDER_DEPTH = process.env.VUE_APP_MAX_FOLDER_DEPTH || 10
const MAX_PRESENTATION_IN_FOLDER = process.env.VUE_APP_MAX_PRESENTATION_IN_FOLDER || 200
const keyRecapcha = process.env.VUE_APP_KEYRECAPTCHA
const mceEditorKey = process.env.VUE_APP_MCE_EDITOR
const accountRemovalURL = env === 'production' ? 'https://ahaslides.com/' : `${presenterDomain}/`
const region = process.env.VUE_APP_REGION || 'gb'
const paypalClientId = process.env.VUE_APP_PAYPAL_CLIENT_ID
const configFile = `${process.env.VUE_APP_CLOUD_FRONT_PUBLIC_URL}/configurations/${env === 'production' ? 'config' : 'config-dev'}.json`
const enableZoho = process.env.VUE_APP_ZOHO_ENABLE
  && process.env.VUE_APP_ZOHO_ENABLE === 'true'
const ssrDomain = process.env.VUE_APP_SSR_DOMAIN
const landingSiteDomain = process.env.VUE_APP_LANDING_SITE_DOMAIN
const openTokKey = process.env.VUE_APP_OPENTOK_KEY
const powerpointDomain = process.env.VUE_APP_POWERPOINT_URL
const ga4Id = process.env.VUE_APP_GA4_ID
const cloudfrontPublic = process.env.VUE_APP_CLOUD_FRONT_PUBLIC_URL
const oneSignalAppId = process.env.VUE_APP_ONESINGAL_APP_ID
const youtubeAPIKey = process.env.VUE_APP_YOUTUBE_API_KEY
const isEnableAddinPowerpoint = process.env.VUE_APP_ENABLE_ADD_IN_POWERPOINT === 'true'
// Public OAuth client_id for the PowerPoint add-in device grant (RFC 8628).
// No secret — the device flow authenticates by client_id only.
const powerpointOAuthClientId = process.env.VUE_APP_POWERPOINT_OAUTH_CLIENT_ID
const cryptoEncryptionKey = process.env.VUE_APP_CRYPTO_ENCRYPTION_KEY
const googleClientId = process.env.VUE_APP_GOOGLE_CLIENT_ID
const gtmId = process.env.VUE_APP_GTM_ID
const mqttBrokerUrl = process.env.VUE_APP_MQTT_BROKER_URL
const unleashClientKey = process.env.VUE_APP_UNLEASH_CLIENT_KEY
const basePlanBenefit = process.env.VUE_APP_PLAN_BENEFIT_URL
const integrationPlatform = process.env.VUE_APP_INTEGRATION_PLATFORM
const googleSlideWebUrl = process.env.VUE_APP_GOOGLE_SLIDE_WEBURL
const livestatsTopicPrefix = process.env.VUE_APP_LIVESTATS_TOPIC_PREFIX
const unleashEndpoint = process.env.VUE_APP_UNLEASH_ENDPOINT
const appOrigin = env === 'production' ? 'ahaslides.com' : 'ahaslide.com'
const powerpointCallBack = process.env.VUE_APP_POWERPOINT_CALLBACK
// https://cookie-script.com
// this is the id of the script that is loaded on the page, not related to any of our cookies
const cookieScriptId = env === 'production' ? '36e3b3eb25b48c8a773bbac55ae1d23a' : '2fb6d84d1904b054cc6132d20345fe23'
const liveProxyUrl = process.env.VUE_APP_LIVE_PROXY_URL || baseUrl
// This one need to be config, but atm we don't have the local version yet so I choose to falling back to staging url
// The reason is the remote control app is in development by the vendor team
const remoteControlUrl = process.env.VUE_APP_REMOTE_CONTROL_URL || 'https://remote.staging.ahaslide.com'
const recaptchaV3Key = process.env.VUE_APP_RECAPTCHA_V3_KEY
const publicLanggraphApiUrl = process.env.VUE_APP_PUBLIC_LANGGRAPH_API_URL
const publicDocumentSystemApiUrl = process.env.VUE_APP_PUBLIC_DOCUMENT_SYSTEM_API_URL
const ahaaiv2Url = process.env.VUE_APP_AHAAIV2_URL
const aiInsightsApiUrl = publicLanggraphApiUrl ? `${publicLanggraphApiUrl}/insights` : undefined
const mixpanelLocalStorageRolloutWeight = parseInt(process.env.VUE_APP_MIXPANEL_LOCALSTORAGE_ROLLOUT_WEIGHT, 10) || 0
const cacheProfileRolloutWeight = parseInt(process.env.VUE_APP_CACHE_PROFILE_ROLLOUT_WEIGHT, 10) || 0
const oauthLoginRolloutWeight = parseInt(process.env.VUE_APP_OAUTH_LOGIN_ROLLOUT_WEIGHT, 10) || 0
// Rollout for all local environment.
// This should be 100% on staging and canary as well
// This should be 20% on production
const unleashMechanismRolloutWeight = process.env.VUE_APP_UNLEASH_MECHANISM_ROLLOUT_WEIGHT !== undefined
  ? parseInt(process.env.VUE_APP_UNLEASH_MECHANISM_ROLLOUT_WEIGHT, 10)
  : 100

const streamlitUrl = process.env.VUE_APP_STREAMLIT_URL

window.enableMixpanel = () => {
  localStorage.setItem('mt-enabled', 'true')
}

window.PRESENTER_APP_VERSION = '1.0.0'

const slidePluginUrl = process.env.VUE_APP_SLIDE_PLUGIN_URL
const ahaslideMarketplaceUrl = process.env.VUE_APP_AHASLIDES_MARKETPLACE_URL || 'https://aha-slide-types-creator.pages.dev/'
const reportAppUrl = process.env.VUE_APP_REPORT_APP_URL
const onboardingAppUrl = process.env.VUE_APP_ONBOARDING_APP_URL
const teamManagementAppUrl = process.env.VUE_APP_TEAM_MANAGEMENT_URL
// Comma-separated hostnames where ?onboardingSandbox=<sha>&onboardingVariant=<key>
// query params are honored (dev-only iframe override). Empty / unset on
// production env files so the override is naturally inert there.
const onboardingSandboxAllowedHosts = (process.env.VUE_APP_ONBOARDING_SANDBOX_ALLOWED_HOSTS || '')
  .split(',')
  .map((h) => h.trim())
  .filter(Boolean)
const landingSiteUrl = env === 'production' ? 'https://ahaslides.com/' : 'https://dev.ahaslide.com/'
const reditusProductId = process.env.VUE_APP_REDITUS_PRODUCT_ID || ''

export default {
  baseUrl,
  liveProxyUrl,
  baseLiveApiUrl,
  kvSyncApiUrl,
  kvSyncApiBasePath,
  baseUrlSocket,
  basePlanBenefit,
  domain,
  backstageDomain,
  sentry,
  sentryEnabled,
  sentryRelease,
  env,
  baseSupportUrl: workerUrl,
  presenterDomain,
  audienceDomain: env === 'local' ? `http://${audienceLink}` : `https://${audienceLink}`,
  audienceHttpsEndpoint: `https://${audienceLink}`,
  audienceLink,
  aiChatbotDomain,
  skoletubeHomepage: 'https://www.skoletube.dk/',
  unleashEndpoint,
  accountRemovalURL: `${accountRemovalURL}?utm_source=presenter_app&utm_medium=presenter_app&utm_campaign=account_deletion_completed`,
  keyRecapcha,
  mceEditorKey,
  region,
  paypalClientId,
  enableZoho,
  ssrDomain,
  landingSiteDomain,
  openTokKey,
  powerpointDomain,
  cloudfrontPublic,
  oneSignalAppId,
  youtubeAPIKey,
  isEnableAddinPowerpoint,
  powerpointOAuthClientId,
  cryptoEncryptionKey,
  mixpanel: {
    projectToken: process.env.VUE_APP_MIXPANEL_PROJECT_TOKEN,
    proxyUrl: process.env.VUE_APP_MIXPANEL_PROXY_URL,
  },
  googleClientId,
  integrationPlatform,
  googleSlideWebUrl,
  powerpointCallBack,
  recaptchaV3Key,
  publicLanggraphApiUrl,
  publicDocumentSystemApiUrl,
  ahaaiv2Url,
  aiInsightsApiUrl,
  unleashMechanismRolloutWeight,
  mixpanelLocalStorageRolloutWeight,
  cacheProfileRolloutWeight,
  oauthLoginRolloutWeight,
  slidePluginUrl,
  ahaslideMarketplaceUrl,
  api: {
    createAccount: `${baseUrl}/api/users/create-presenter/`,
    createSkoletubePresenter: `${baseUrl}/api/users/create-skoletube-presenter/`,
    updateUserSettings: `${baseUrl}/api/users/update-settings`,
    login: `${baseUrl}/api/auth/presenter/`,
    account: `${baseUrl}/api/users/account/`,
    resetPassword: `${baseUrl}/api/reset-password/email/`,
    confirmPassword: `${baseUrl}/api/reset-password/confirm/`,
    createPresentation: `${baseUrl}/api/presentation/create/`,
    getPresentationDetail: `${baseUrl}/api/presentation/detail/`,
    getPresentationBasic: `${baseUrl}/api/presentation/basic/`,
    updatePresentation: `${baseUrl}/api/presentation/update/`,
    sortSlide: `${baseUrl}/api/slide/sort-slide/`,
    getSlides: `${baseUrl}/api/slide/list/`,
    getCategories: `${baseUrl}/api/presentation/categories/for-presentations/`,
    getCategoryDetail: `${baseUrl}/api/presentation/categories/detail-for-presenter/`,
    getCategoryTemplates: `${baseUrl}/api/category/{id}/templates/`,
    duplicateSlideToOtherPresentation: `${baseUrl}/api/slide/duplicate-other-presentation/`,
    updateSlide: `${baseUrl}/api/slide/update/`,
    createSlide: `${baseUrl}/api/slide/create/`,
    duplicateSlide: `${baseUrl}/api/slide/duplicate/`,
    createSlideOption: `${baseUrl}/api/slide-option/create/`,
    updateSlideOption: `${baseUrl}/api/slide-option/update/`,
    updateEventSlideOption: `${baseUrl}/api/slide-option/update-event/`,
    removeWordCloud: `${baseUrl}/api/slide-option/remove-wordcloud/`,
    /** @deprecated use resizeImageWithLambda */
    uploadSlideOptionImage: `${baseUrl}/api/slide-option/slide-option-image/`,
    updateStatusResult: `${baseUrl}/api/presentation/status-result/`,
    changeAccessCode: `${baseUrl}/api/presentation/change-access-code/`,
    /** @deprecated use resizeImageWithLambda */
    uploadSlideImage: `${baseUrl}/api/slide/slide-image/`,
    /** @deprecated use resizeImageWithLambda */
    resizeImage: `${baseUrl}/api/upload/resize/`,
    resizeImageWithLambda: `${baseUrl}/api/upload/resize-images/`,
    resizeCustomThumbnailImage: `${baseUrl}/api/upload/resize-custom-thumbnail/`,
    uploadPresentationLogo: `${baseUrl}/api/presentation/upload-logo/`,
    applyBackgroundConfigSlide: `${baseUrl}/api/slide/slide-apply-background/`,
    duplicatePresentation: `${baseUrl}/api/presentation/duplicate/`,
    sharePresentation: `${baseUrl}/api/presentation/share-presentation/`,
    copyPresentation: `${baseUrl}/api/presentation/copy-presentation/`,
    getAudienceOnline: `${baseUrl}/api/presentation/count-audience/`,
    getResultLeaderboard: `${baseUrl}/api/slide/slide-leaderboard/`,
    getDetailPricing: `${baseUrl}/api/pricing/plan-detail/`,
    getIdealPaymentMethod: `${baseUrl}/api/pricing/payment-method-ideal/`,
    idealCheckout: `${baseUrl}/api/pricing/create-session-checkout-ideal/`,
    checkInvoicePaid: `${baseUrl}/api/pricing/check-invoice-paid/`,
    checkout: `${baseUrl}/api/pricing/checkout/`,
    checkoutUpgradePlan: `${baseUrl}/api/pricing/upgrade/`,
    myPlan: `${baseUrl}/api/pricing/my-plan/`,
    paymentHookSlack: `${baseUrl}/api/pricing/hook-slack/`,
    getInvoiceIdBySessionId: `${baseUrl}/api/pricing/get-invoice-by-session-id/`,
    getCustomerStripeForMethodCard: `${baseUrl}/api/pricing/get-customer-stripe-for-card/`,
    clearAudienceData: `${baseUrl}/api/presentation/clear-data-audience/`,
    uploadImage: `${baseUrl}/api/upload/image/`,
    uploadXlsx: `${workerUrl}/api/upload/xlsx/`,
    publicUpload: `${baseUrl}/api/upload/public-upload`,
    uploadLink: `${baseUrl}/api/upload/link/`,
    getQuestion: `${baseUrl}/api/question/list/`,
    updateQuestion: `${baseUrl}/api/question/update/`,
    clearDataSlide: `${baseUrl}/api/slide/clear-data/`,
    confirmCheckout: `${baseUrl}/api/pricing/confirm-checkout/`,
    importDocument: `${baseUrl}/api/presentation/import-document/`,
    changeSubscription: `${baseUrl}/api/pricing/change-status-subscription/`,
    quizHook: `${baseUrl}/api/hook/quiz/`,
    createLeaderboard: `${baseUrl}/api/slide/presenter-create-leaderboard/`,
    updateNextSlide: `${baseUrl}/api/presentation/update-next-slide/`,
    collabNextSlide: `${baseUrl}/api/collab/next-slide/`,
    getDataQuizTypeAnswer: `${baseUrl}/api/answer/quiz-type-answer/`,
    searchUnsplash: `${baseUrl}/api/slide/search-unsplash`,
    searchGiphy: `${baseUrl}/api/slide/search-giphy`,
    checkQuizTeamMember: `${baseUrl}/api/quiz/set-team-data/`,
    invoice: `${baseUrl}/api/invoice/`,
    removeCards: `${baseUrl}/api/pricing/remove-card/`,
    updateCard: `${baseUrl}/api/pricing/update-card/`,
    slideScaleQuestion: `${baseUrl}/api/slide/scale-result/`,
    removeUserAccount: `${baseUrl}/api/users/`,
    getInvitation: `${baseUrl}/api/users/invitation/`,
    googleSignin: `${baseUrl}/api/auth/google/`,
    microsoftSignin: `${baseUrl}/api/auth/microsoft/`,
    googleSigninPPT: `${baseUrl}/api/auth/google/powerpoint-google/`,
    importFileSheet: `${baseUrl}/api/presentation/import-sheet/`,
    stopVideoCall: `${baseUrl}/api/webrtc/stop/`,
    searchGiphySticker: `${baseUrl}/api/slide/search-giphy-stickers`,
    signInZoho: `${baseUrl}/api/zoho-authn/jwt/signin_url`,
  },
  workerApi: {
    exportPdf: `${workerUrl}/api/export/pdf/`,
    // AHA-46264: v2 async PDF export. Neutral name/path on purpose — the renderer
    // behind it is a server-side detail, not exposed to the client.
    exportPdfV2: `${workerUrl}/api/export/pdf/v2`,
    exportExcel: `${workerUrl}/api/export/excel/`,
    exportExcelV3: `${workerUrl}/api/export/excel/v3`,
    exportExcelV4: `${workerUrl}/api/export/excel/v4`,
    exportExcelV5: `${workerUrl}/api/export/excel/v5`,
    exportPdfForSharedReport: `${workerUrl}/api/export/shared-report/export/pdf/`,
    exportExcelForSharedReport: `${workerUrl}/api/export/shared-report/excel`,
    exportExcelV3ForSharedReport: `${workerUrl}/api/export/shared-report/excel/v3`,
    exportExcelV4ForSharedReport: `${workerUrl}/api/export/shared-report/excel/v4`,
    exportExcelForSharedReportV5: `${workerUrl}/api/export/shared-report/excel/v5`,
    uploadFileDocument: `${workerUrl}/api/upload/file-document/`,
    uploadFileDocumentV2: `${workerUrl}/api/upload/file-document/v2/`,
    uploadFileAudio: `${workerUrl}/api/upload/file-audio/`,

    sessionExportPdf: `${workerUrl}/api/presenting-sessions/export/pdf/`,
    sessionExportExcel: `${workerUrl}/api/presenting-sessions/export/excel/`,
    sessionExportExcelV2: `${workerUrl}/api/presenting-sessions/export/excel/v2`,
    sessionExportExcelV3: `${workerUrl}/api/presenting-sessions/export/excel/v3`,
    sessionExportExcelV4: `${workerUrl}/api/presenting-sessions/export/excel/v4`,
    sessionExportExcelV5: `${workerUrl}/api/presenting-sessions/export/excel/v5`,
  },
  externalApis: {
    pptPdfUpload: `${publicLanggraphApiUrl}/document-system/api/file`,
    pptPdfImport: `${publicLanggraphApiUrl}/ahaslides/api/file:import`,
    pptPdfUploadUsingDocumentSystem: `${publicDocumentSystemApiUrl}/api/docsys/document-system/api/file`,
    pptPdfImportUsingDocumentSystem: `${publicDocumentSystemApiUrl}/api/docsys/ahaslides/api/file:import`,
    pptPdfImportAsync: `${publicDocumentSystemApiUrl}/api/docsys/ahaslides/api/file:import-async`,
    pptPdfImportJobStatus: `${publicDocumentSystemApiUrl}/api/docsys/ahaslides/api/import-job`,
    cloudImport: `${publicDocumentSystemApiUrl}/api/docsys/document-system/api/cloud-import`,
    aiInsightsBase: `${publicLanggraphApiUrl}/api/report-insight/presentation`,
    aiInsightsBaseV2: ahaaiv2Url ? `${ahaaiv2Url}/api/ai-v2/report-insight/presentation` : undefined,
  },
  EXIT_KEYS: ['Escape'],
  NEXT_SLIDE_KEYS: ['ArrowRight', 'PageDown', 'Space'],
  DISABLE_ON_FOCUS_SLIDE_KEYS: ['Space', 'Enter', 'ArrowRight', 'ArrowLeft'],
  LAST_SLIDE_KEYS: ['ArrowLeft', 'PageUp'],
  ENTER_FULL_SCREEN_KEYS: ['KeyF'],
  START_QUIZ_KEYS: ['Enter', 'Space'],
  SLIDE_CONTROLS_TIMEOUT: 2000,
  PRO_TIPS: [
    'While presenting, press F to present in full screen mode.',
    'While presenting, use the settings menu to the left to find more features',
  ],
  US_PRESENTING_MODE: 'Presenting Mode',
  LABEL_USER_INTERACTION: 'User Interaction',
  stripePublicKey,
  singaporeStripePublishableKey,
  MAX_NUMBER_OF_SLIDE,
  MAX_FOLDER_DEPTH,
  MAX_PRESENTATION_IN_FOLDER,
  configFile,
  ga4Id,
  gtmId,
  mqttBrokerUrl,
  unleashClientKey,
  livestatsTopicPrefix,
  appOrigin,
  cookieScriptId,
  remoteControlUrl,
  LiveProxyRootPath: process.env.VUE_APP_LIVEPROXY_ROOT_PATH || 'live-v2',
  newKafkaClusterPrefix: process.env.VUE_APP_NEWKAFKA_PREFIX, // overwrite to allow staging test
  streamlitUrl,
  reportAppUrl,
  onboardingAppUrl,
  teamManagementAppUrl,
  onboardingSandboxAllowedHosts,
  landingSiteUrl,
  reditusProductId,
}
